import { Button } from '@insta-club/ui';
import { cn } from '@insta-club/utilities';
import Link from 'next/link';

function EmptyContent({
    icon,
    title,
    description,
    action,
    titleClassName,
    descriptionClassName
}: {
    icon: React.ReactNode;
    title: string;
    description: string;
    action?: {
        href: string;
        icon: React.ReactNode;
        label: string;
    };
    titleClassName?: string;
    descriptionClassName?: string;
}) {
    return (
        <div className='mt-[80px] flex flex-col items-center'>
            <div className='mb-8 flex items-center justify-center rounded-[30px] bg-gray-100 p-6'>{icon}</div>
            <h4 className={cn('mb-4 text-base font-bold text-gray-800', titleClassName)}>{title}</h4>
            <p className={cn('text-center text-[15px] font-medium text-gray-500', descriptionClassName)}>
                {description}
            </p>
            {action && (
                <>
                    <Link href={action.href} className='mt-8'>
                        <Button icon={action.icon} className='bg-primary-700! px-4! py-3.5! text-base! font-medium!'>
                            {action.label}
                        </Button>
                    </Link>
                </>
            )}
        </div>
    );
}

export default EmptyContent;

